module.exports = __webpack_public_path__ + "static/templates/bulk-upload-v2-th.2-sY1Kd.xlsx";